/* AVERRA PRO — theme.js (vanilla, no deps). Cart engine adapted from a proven live-cart pattern. */
(function(){
  "use strict";
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const money=(c)=>{const v=c/100;return 'Rs. '+v.toLocaleString('en-IN',{minimumFractionDigits:v%1?2:0,maximumFractionDigits:2});};

  /* ---------- reveal on scroll ---------- */
  function reveal(){
    const els=$$('.rv');
    if(!('IntersectionObserver'in window)||document.body.classList.contains('no-anim')){els.forEach(e=>e.classList.add('in'));return;}
    const io=new IntersectionObserver((en)=>{en.forEach(e=>{if(e.isIntersecting){const d=e.target.dataset.delay||0;setTimeout(()=>e.target.classList.add('in'),d);io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(e=>io.observe(e));
  }

  /* ---------- drawers ---------- */
  function openDrawer(el){const sc=$('.scrim');el.classList.add('open');if(sc)sc.classList.add('open');document.body.style.overflow='hidden';}
  function closeDrawers(){$$('.drawer').forEach(d=>d.classList.remove('open'));const sc=$('.scrim');if(sc)sc.classList.remove('open');document.body.style.overflow='';}
  function drawers(){
    const sc=$('.scrim');
    $$('[data-open-cart]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();const d=$('.drawer.cart');if(d){openDrawer(d);refreshCart();}}));
    $$('[data-open-drawer]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();const sel=b.getAttribute('data-open-drawer');const d=$(sel);if(d)openDrawer(d);}));
    $$('[data-close-drawer]').forEach(b=>b.addEventListener('click',closeDrawers));
    if(sc)sc.addEventListener('click',closeDrawers);
    addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawers();});
  }

  /* ---------- cart ---------- */
  // B2G1: every 3rd item free. Progress toward next free item.
  function b2g1Box(cart){
    const d=$('.drawer.cart');if(!d||d.dataset.b2g1==='false')return '';
    const qty=cart.item_count||0;
    const rem=qty%3, need=rem===0?0:(3-rem), step=rem===0?3:rem;
    const pct=qty===0?0:(rem===0?100:Math.round(rem/3*1000)/10);
    const done=qty>0&&need===0;
    const chip=done?'<span class="b2g1c__chip is-done">Unlocked ✓</span>':`<span class="b2g1c__chip">${step}/3</span>`;
    const foot=done?'Free fragrance applied 🎁':`Add <b>${need}</b> more to unlock your free fragrance`;
    return `<div class="b2g1c ${done?'is-done':''}">
      <div class="b2g1c__top"><span class="b2g1c__title">🎁 Buy 2 Get 1 Free</span>${chip}</div>
      <div class="b2g1c__bar"><div class="b2g1c__fill" style="width:${pct}%"></div></div>
      <div class="b2g1c__foot"><span>${foot}</span></div>
    </div>`;
  }

  // Applied discount codes -> horizontal slider of removable chips
  // collect applied discounts with ACCURATE amounts from real allocations.
  // Sources: line_level_discount_allocations (B2G1 free item, line discounts)
  //          + cart_level_discount_applications (order/code discounts).
  function getDiscounts(cart){
    // amount actually saved per discount title, summed across line + cart level
    const amtByTitle={};
    const add=(title,amt)=>{const t=(title||'').trim();if(!t||!amt)return;const k=t.toUpperCase();amtByTitle[k]=(amtByTitle[k]||0)+amt;};
    // line-level (each item's allocations -> discount_application.title)
    (cart.items||[]).forEach(it=>{
      (it.line_level_discount_allocations||[]).forEach(al=>{
        const t=al.discount_application&&(al.discount_application.title||al.discount_application.code);
        add(t,al.amount||0);
      });
    });
    // cart-level applications
    (cart.cart_level_discount_applications||[]).forEach(a=>add(a.title||a.code,a.total_allocated_amount||0));

    // which titles correspond to typed (removable) codes
    const codeTitles={};
    (cart.discount_codes||[]).forEach(dc=>{ if(dc.code&&dc.applicable!==false)codeTitles[dc.code.toUpperCase()]=dc.code; });

    const codes=[],autos=[];const used={};
    // typed codes first (so they're removable), using their measured amount
    Object.keys(codeTitles).forEach(k=>{ used[k]=1; codes.push({title:codeTitles[k],amt:amtByTitle[k]||0}); });
    // everything else with a measured amount = automatic (B2G1 etc.)
    Object.keys(amtByTitle).forEach(k=>{ if(used[k])return; used[k]=1;
      // find a nicely-cased title from applications if available
      let nice=k;
      (cart.cart_level_discount_applications||[]).forEach(a=>{const t=(a.title||a.code||'');if(t.toUpperCase()===k)nice=t;});
      (cart.items||[]).forEach(it=>(it.line_level_discount_allocations||[]).forEach(al=>{const da=al.discount_application;const t=da&&(da.title||da.code)||'';if(t.toUpperCase()===k)nice=t;}));
      autos.push({title:nice,amt:amtByTitle[k]});
    });
    return {codes,autos};
  }
  function discountChips(cart){
    const {codes}=getDiscounts(cart);
    if(!codes.length)return '';
    const chips=codes.map(c=>`<div class="dchip">
        <span class="dchip__tag">🏷️</span>
        <span class="dchip__code">${c.title}</span>
        ${c.amt>0?`<span class="dchip__amt">− ${money(c.amt)}</span>`:''}
        <button class="dchip__x" data-remove-discount="${encodeURIComponent(c.title)}" aria-label="Remove ${c.title}">×</button>
      </div>`).join('');
    return `<div class="dchips" data-dchips><div class="dchips__track">${chips}</div></div>`;
  }

  function renderCart(cart){
    const d=$('.drawer.cart');
    const body=$('.drawer.cart .drawer__body'),foot=$('.drawer.cart .drawer__foot');
    $$('.cart-pill').forEach(p=>p.textContent=cart.item_count||'');
    const title=$('[data-cart-title]');if(title)title.textContent=cart.item_count?`Your Cart (${cart.item_count})`:'Your Cart';
    if(!body)return;
    if(!cart.item_count){
      body.innerHTML='<div class="cart-empty"><div class="cart-empty__ic">🛍️</div><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--accent" data-close-drawer>Discover fragrances</a></div>';
      if(foot)foot.innerHTML='';bindCart();return;
    }
    const trash='<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6"/></svg>';
    let html=b2g1Box(cart);
    html+=discountChips(cart);
    html+='<div class="clines">';
    cart.items.forEach((it,i)=>{
      const opts=it.options_with_values||[];
      let variantVal='';
      for(const o of opts){if(o.value&&o.value!=='Default Title'){variantVal=o.value;break;}}
      const purl=it.url||('/products/'+(it.handle||''));
      const alloc=(it.line_level_discount_allocations||[]);
      const discounted=alloc.reduce((s,a)=>s+(a.amount||0),0);
      const isFree=it.final_line_price===0||discounted>=it.original_line_price;
      let tag='';
      if(isFree){tag='<span class="cline__gift">🎁 FREE</span>';}
      else if(cart.item_count>=3){tag='<span class="cline__b2g1">B2G1</span>';}
      // variant + tag share one horizontal line so the card never grows taller
      const metaParts=[];
      if(variantVal)metaParts.push(`<span class="cline__v">${variantVal}</span>`);
      if(tag)metaParts.push(tag);
      const meta=metaParts.length?`<div class="cline__meta">${metaParts.join('')}</div>`:'';
      const priceHtml=isFree?'<span class="cline__free">FREE</span>':money(it.final_line_price);
      const img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):'';
      html+=`<div class="cline ${isFree?'is-free':''}">
        <a href="${purl}" class="cline__imglink" data-close-drawer><img class="cline__img" src="${img}" alt="" loading="lazy"></a>
        <div class="cline__mid">
          <a href="${purl}" class="cline__t" data-close-drawer>${it.product_title}</a>${meta}
          <div class="cline__row">
            <div class="cline__qty"><button data-dec="${i}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-inc="${i}" aria-label="Increase">+</button></div>
            <button class="cline__rm" data-rm="${i}" aria-label="Remove item">${trash}</button>
            <div class="cline__price">${priceHtml}</div>
          </div>
        </div></div>`;
    });
    html+='</div>';
    html+='<div class="cart-recs" data-recs></div>';
    const prevTop=body.scrollTop;
    body.innerHTML=html;
    if(prevTop)body.scrollTop=prevTop;
    animateProgress();
    if(foot){
      const disc=parseFloat((d&&d.dataset.prepaid)||'5')||0;
      const sub=money(cart.total_price);
      const mrp=cart.original_total_price;
      const {codes,autos}=getDiscounts(cart);
      // sum of itemised discounts we can name
      const totalSaved=mrp-cart.total_price;
      let named=0; codes.forEach(c=>named+=c.amt||0); autos.forEach(a=>named+=a.amt||0);
      const rows=[`<div class="csum__r"><span>MRP Total</span><span>${money(mrp)}</span></div>`];
      // automatic discounts (B2G1 etc.) with their real measured amounts
      autos.forEach(a=>{ if(a.amt>0)rows.push(`<div class="csum__r"><span>${a.title}</span><span class="csum__disc">− ${money(a.amt)}</span></div>`); });
      // typed codes with their real measured amounts
      codes.forEach(c=>{ if(c.amt>0)rows.push(`<div class="csum__r"><span>Code: ${c.title}</span><span class="csum__disc">− ${money(c.amt)}</span></div>`); });
      // safety net: if allocations don't fully add up to the saving, show the gap once
      const gap=totalSaved-named;
      if(gap>0)rows.push(`<div class="csum__r"><span>Additional savings</span><span class="csum__disc">− ${money(gap)}</span></div>`);
      rows.push(`<div class="csum__r"><span>Shipping</span><span class="csum__free">FREE</span></div>`);
      const breakdown=`<div class="csum__rows" data-csum-rows hidden>${rows.join('')}</div>`;
      const prepaidBadge=disc>0?`<span class="csum__prepaid">${disc}% off online</span>`:'';
      foot.innerHTML=`
        <form class="ccode" data-cart-code>
          <input type="text" name="discount" placeholder="Discount code" autocomplete="off" aria-label="Discount code">
          <button type="submit" class="ccode__btn">Apply</button>
        </form>
        <div class="csum">
          ${breakdown}
          <button type="button" class="csum__bar" data-csum-toggle aria-expanded="false">
            <span class="csum__total"><b>${sub}</b><i>Inclusive of all taxes</i></span>
            <span class="csum__right">${prepaidBadge}<svg class="csum__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 15l6-6 6 6"/></svg></span>
          </button>
        </div>
        <a href="/checkout" class="btn btn--accent btn--block cbtn">Place Order</a>`;
    }
    loadRecs(cart.items[0]?cart.items[0].product_id:0);
    bindCart();
  }

  var _progWidths={};
  function animateProgress(){
    const f=$('.b2g1c__fill');if(!f)return;
    const target=f.style.width||'0%';
    const prev=_progWidths.main||'0%';
    f.style.transition='none';f.style.width=prev;void f.offsetWidth;
    requestAnimationFrame(()=>{f.style.transition='';f.style.width=target;});
    _progWidths.main=target;
  }
  function bindCart(){
    $$('[data-inc]').forEach(b=>b.onclick=()=>changeQty(+b.dataset.inc,1));
    $$('[data-dec]').forEach(b=>b.onclick=()=>changeQty(+b.dataset.dec,-1));
    $$('[data-rm]').forEach(b=>b.onclick=()=>changeLine(+b.dataset.rm,0));
    // collapsible totals (boAt-style)
    const tog=$('[data-csum-toggle]');
    if(tog){tog.onclick=()=>{
      const rows=$('[data-csum-rows]');if(!rows)return;
      const open=!rows.hasAttribute('hidden');
      if(open){rows.setAttribute('hidden','');tog.setAttribute('aria-expanded','false');}
      else{rows.removeAttribute('hidden');tog.setAttribute('aria-expanded','true');}
    };}
    // discount code apply -> cart/update.js discount param (Shopify Editions '25), real-time
    const codeForm=$('[data-cart-code]');
    if(codeForm){codeForm.onsubmit=(e)=>{
      e.preventDefault();
      const inp=codeForm.querySelector('input');const code=(inp.value||'').trim();if(!code)return;
      const btn=codeForm.querySelector('button');const o=btn.textContent;btn.textContent='…';btn.disabled=true;
      // merge with any already-applied codes so we don't drop them
      getCart().then(c=>{
        const existing=(c.discount_codes||[]).filter(x=>x.applicable!==false).map(x=>x.code).filter(Boolean);
        if(existing.indexOf(code)<0)existing.push(code);
        return applyDiscounts(existing);
      }).then(c=>{
        renderCart(c);
        // if the code didn't stick, it was invalid
        const applied=(c.discount_codes||[]).some(x=>(x.code||'').toLowerCase()===code.toLowerCase()&&x.applicable!==false);
        const f=$('[data-cart-code]');
        if(f){const b=f.querySelector('button');const i=f.querySelector('input');
          if(applied){i.value='';b.textContent='Apply';b.disabled=false;}
          else{b.textContent='Invalid';setTimeout(()=>{b.textContent='Apply';b.disabled=false;},1400);}
        }
      }).catch(()=>{btn.textContent=o;btn.disabled=false;});
    };}
    // remove an applied discount chip
    $$('[data-remove-discount]').forEach(x=>x.onclick=()=>{
      const code=decodeURIComponent(x.getAttribute('data-remove-discount'));
      getCart().then(c=>{
        const remain=(c.discount_codes||[]).filter(x=>x.applicable!==false).map(x=>x.code).filter(Boolean)
                      .filter(t=>t.toLowerCase()!==code.toLowerCase());
        return applyDiscounts(remain);
      }).then(renderCart).catch(()=>{});
    });
  }
  function applyDiscounts(codes){
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({discount:(codes||[]).join(',')})}).then(r=>r.json());
  }
  function getCart(){return fetch('/cart.js').then(r=>r.json());}
  function refreshCart(){getCart().then(renderCart).catch(()=>{});}
  function changeQty(i,delta){getCart().then(c=>{const it=c.items[i];if(it)changeLine(i,it.quantity+delta);});}
  function changeLine(i,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:i+1,quantity:qty})}).then(r=>r.json()).then(renderCart);}
  function toast(msg){
    let t=$('#averra-toast');
    if(!t){t=document.createElement('div');t.id='averra-toast';t.className='averra-toast';document.body.appendChild(t);}
    t.textContent=msg;t.classList.add('show');
    clearTimeout(t._h);t._h=setTimeout(()=>t.classList.remove('show'),3200);
  }
  function addToCart(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})})
      .then(r=>r.json().then(data=>({ok:r.ok,status:r.status,data})))
      .then(res=>{
        if(!res.ok){
          const m=(res.data&&(res.data.description||res.data.message))||'Sorry, this item could not be added.';
          toast(m);throw new Error(m);
        }
        const d=$('.drawer.cart');if(d)openDrawer(d);refreshCart();return res.data;
      });
  }
  function wireRecsArrows(box){
    const rail=box.querySelector('[data-recs-rail]'),
          prev=box.querySelector('[data-recs-prev]'),next=box.querySelector('[data-recs-next]');
    if(!rail||!prev||!next)return;
    const step=()=>Math.max(160,rail.clientWidth*0.8);
    const update=()=>{
      const max=rail.scrollWidth-rail.clientWidth-2;
      prev.classList.toggle('off',rail.scrollLeft<=2);
      next.classList.toggle('off',rail.scrollLeft>=max);
      const scrollable=rail.scrollWidth>rail.clientWidth+4;
      prev.style.display=next.style.display=scrollable?'':'none';
    };
    prev.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
    rail.addEventListener('scroll',update,{passive:true});
    setTimeout(update,50);
  }
  function loadRecs(pid){
    const box=$('[data-recs]');if(!box||!pid){if(box)box.innerHTML='';return;}
    fetch('/recommendations/products.json?product_id='+pid+'&limit=6&intent=related&_='+Date.now()).then(r=>r.json()).then(d=>{
      const items=(d.products||[]).slice(0,6);if(!items.length){box.innerHTML='';return;}
      box.innerHTML='<div class="cart-recs__h">You may also like</div>'+
        '<div class="cart-recs__wrap"><button class="cart-recs__nav cart-recs__nav--prev" data-recs-prev aria-label="Previous">‹</button>'+
        '<div class="cart-recs__r" data-recs-rail>'+items.map(p=>{
        const img=p.featured_image||(p.images&&p.images[0])||'';const v=p.variants&&p.variants[0];
        let cents=0;if(v){if(typeof v.price==='number')cents=v.price;else if(v.price!=null)cents=Math.round(parseFloat(v.price)*100);}
        const price=v?money(cents):'';
        return `<div class="crec"><a href="${p.url}" class="crec__lk">${img?`<img src="${img}" alt="" loading="lazy">`:''}<span class="crec__t">${p.title}</span>${price?`<span class="crec__p">${price}</span>`:''}</a>${v?`<button class="crec__a" data-add="${v.id}" aria-label="Add to cart">+ Add</button>`:''}</div>`;
      }).join('')+'</div>'+
        '<button class="cart-recs__nav cart-recs__nav--next" data-recs-next aria-label="Next">›</button></div>';
      wireRecsArrows(box);
    }).catch(()=>{box.innerHTML='';});
  }

  /* quick add (delegated) — product cards & rec cards */
  function quickAdd(){
    document.addEventListener('click',e=>{
      const opt=e.target.closest('[data-card-options]');
      if(opt){e.preventDefault();window.location.href=opt.getAttribute('data-card-options');return;}
      const b=e.target.closest('[data-add]');if(!b)return;
      e.preventDefault();const id=b.dataset.add;if(!id){const lk=b.closest('.card');if(lk){const a=lk.querySelector('.card__link');if(a)window.location.href=a.getAttribute('href');}return;}
      if(b.dataset.busy)return;b.dataset.busy='1';
      const card=b.classList.contains('card__cart');
      if(card){b.classList.add('loading');}
      else{var o=b.textContent;b.textContent='Adding…';b.disabled=true;}
      addToCart(id,1).then(()=>{
        if(card){b.classList.remove('loading');b.classList.add('added');setTimeout(()=>{delete b.dataset.busy;b.classList.remove('added');},1300);}
        else{b.textContent='Added ✓';setTimeout(()=>{b.textContent=o;b.disabled=false;delete b.dataset.busy;},1300);}
      }).catch(()=>{delete b.dataset.busy;if(card){b.classList.remove('loading');}else{b.textContent=o;b.disabled=false;}});
    });
  }

  /* ---------- countdowns ---------- */
  function countdowns(){
    $$('[data-countdown]').forEach(el=>{
      const reset=3;
      const nextReset=()=>{const e=new Date();if(e.getHours()>=reset)e.setDate(e.getDate()+1);e.setHours(reset,0,0,0);return e.getTime();};
      let target=nextReset();
      const n={d:$('[data-unit="d"]',el),h:$('[data-unit="h"]',el),m:$('[data-unit="m"]',el),s:$('[data-unit="s"]',el)};
      const p=x=>String(x).padStart(2,'0');
      function tick(){
        if(Date.now()>=target)target=nextReset();
        let diff=Math.max(0,target-Date.now());
        const d=Math.floor(diff/864e5);diff-=d*864e5;
        const h=Math.floor(diff/36e5);diff-=h*36e5;
        const m=Math.floor(diff/6e4);diff-=m*6e4;
        const s=Math.floor(diff/1e3);
        if(n.d)n.d.textContent=p(d);if(n.h)n.h.textContent=p(h);if(n.m)n.m.textContent=p(m);if(n.s)n.s.textContent=p(s);
      }
      tick();setInterval(tick,1000);
    });
  }

  /* ---------- hero carousel ---------- */
  function heroCarousel(){
    $$('[data-carousel]').forEach(c=>{
      const slides=$$('.hero__slide',c),dots=$$('.dots i',c);if(slides.length<2)return;
      let idx=0;const track=$('.hero__slides',c);
      function go(i){idx=(i+slides.length)%slides.length;if(track)track.style.transform='translateX(-'+(idx*100)+'%)';dots.forEach((d,j)=>d.classList.toggle('on',j===idx));}
      dots.forEach((d,j)=>d.addEventListener('click',()=>go(j)));
      setInterval(()=>go(idx+1),4500);go(0);
    });
  }

  /* ---------- bestseller / product sliders (native scroll, no dots) ---------- */

  /* ---------- PDP variant chips ---------- */
  function pdpVariants(){
    const wrap=$('#pdp-variants');if(!wrap)return;
    const amt=$('#pdp-price-amt'),cmp=$('#pdp-price-cmp'),off=$('#pdp-price-off');
    const vids=[$('#pdp-variant-id'),$('#pdp-buy-variant-id')].filter(Boolean);
    function select(chip){
      $$('.pdp__chip',wrap).forEach(c=>c.classList.remove('on'));chip.classList.add('on');
      const price=+chip.dataset.price||0,compare=+chip.dataset.compare||0,id=chip.dataset.variant;
      if(amt&&price)amt.textContent=money(price);
      if(cmp){if(compare>price){cmp.textContent=money(compare);cmp.style.display='';}else cmp.style.display='none';}
      if(off){if(compare>price){off.textContent=Math.round((compare-price)/compare*100)+'% off';off.style.display='';}else off.style.display='none';}
      if(id)vids.forEach(v=>v.value=id);
      if(chip.dataset.image)setMainImage(chip.dataset.image,chip.dataset.mediaId);
    }
    // preload every variant image so swaps are instant
    $$('.pdp__chip',wrap).forEach(chip=>{if(chip.dataset.image)preloadMain(chip.dataset.image);});
    $$('.pdp__chip',wrap).forEach(chip=>chip.addEventListener('click',()=>select(chip)));
    // keep whatever Shopify selected by default; do not disable anything
    const init=wrap.querySelector('.pdp__chip.on')||wrap.querySelector('.pdp__chip');
    if(init)select(init);
  }

  /* ---------- PDP tabs (mobile only) — original behavior ---------- */
  function pdpTabs(){
    $$('.pdp__tabs--mobile').forEach(()=>{}); // no-op marker
    const tabBtns=$$('.pdp__tabs--mobile button[data-tab]');
    tabBtns.forEach(btn=>btn.addEventListener('click',()=>{
      const tgt=btn.getAttribute('data-tab');
      tabBtns.forEach(b=>b.classList.toggle('on',b===btn));
      $$('.pdp__tabs--mobile[data-tabpanel]').forEach(p=>p.style.display=p.getAttribute('data-tabpanel')===tgt?'block':'none');
    }));
  }

  /* ---------- PDP accordion (desktop only) — none open by default ---------- */
  function pdpAccordion(){
    $$('[data-pdp-acc]').forEach(acc=>{
      const heads=$$('.pdp__acc-head',acc);
      heads.forEach(h=>h.addEventListener('click',()=>{
        const k=h.getAttribute('data-acc');
        const pn=acc.querySelector('[data-accpanel="'+k+'"]');
        const open=h.classList.contains('on');
        h.classList.toggle('on',!open);
        if(pn)pn.style.display=open?'none':'block';
      }));
    });
  }

  /* ---------- PDP quantity stepper ---------- */
  function pdpQty(){
    $$('.pdp__qty').forEach(box=>{
      const inp=box.querySelector('input'),dn=box.querySelector('[data-qty-dn]'),up=box.querySelector('[data-qty-up]');
      if(!inp)return;
      const clamp=()=>{let v=parseInt(inp.value,10);if(isNaN(v)||v<1)v=1;inp.value=v;};
      dn&&dn.addEventListener('click',()=>{inp.value=Math.max(1,(parseInt(inp.value,10)||1)-1);});
      up&&up.addEventListener('click',()=>{inp.value=(parseInt(inp.value,10)||1)+1;});
      inp.addEventListener('change',clamp);
    });
  }

  /* ---------- PDP thumbnails ---------- */
  const _imgCache={};
  function preloadMain(src){
    if(!src||_imgCache[src])return _imgCache[src];
    const im=new Image();im.src=src;_imgCache[src]=im;return im;
  }
  function setMainImage(src,mediaId){
    const main=$('#pdp-main');
    if(main&&src&&main.getAttribute('src')!==src){
      const im=preloadMain(src);
      const apply=()=>{main.src=src;};
      // if the preloaded copy is already decoded, swap synchronously (no flash)
      if(im.complete&&im.naturalWidth){apply();}
      else if(im.decode){im.decode().then(apply).catch(apply);}
      else{im.onload=apply;apply();}
    }
    $$('.pdp__thumbs img').forEach(t=>{
      const match=mediaId?(t.dataset.mediaId===String(mediaId)):(t.dataset.full===src);
      t.classList.toggle('on',!!match);
    });
  }
  function pdpThumbs(){
    // preload every full-size gallery image so clicking a thumb swaps instantly
    $$('.pdp__thumbs img').forEach(th=>{if(th.dataset.full)preloadMain(th.dataset.full);});
    $$('.pdp__thumbs img').forEach(th=>th.addEventListener('click',()=>{
      setMainImage(th.dataset.full||th.src,th.dataset.mediaId);
    }));
  }

  /* ---------- PDP add to cart (drawer) ---------- */
  function pdpForm(){
    const forms=[$('form.pdp-sticky__cta'),$('form.pdp__buyform')].filter(Boolean);
    if(!forms.length)return;
    forms.forEach(form=>{
      let lastBtn=null;
      form.addEventListener('click',e=>{const b=e.target.closest('button[type="submit"]');if(b)lastBtn=b;},true);
      form.addEventListener('submit',e=>{
        const isCheckout=lastBtn&&lastBtn.name==='checkout';
        if(isCheckout)return; // BUY NOW proceeds natively
        e.preventDefault();
        const idEl=form.querySelector('#pdp-variant-id,#pdp-buy-variant-id');
        const id=idEl&&idEl.value;if(!id)return;
        const qEl=form.querySelector('#pdp-qty');const qty=Math.max(1,parseInt(qEl&&qEl.value,10)||1);
        const btn=form.querySelector('[data-pdp-add]');let o;
        if(btn){btn.disabled=true;o=btn.textContent;btn.textContent='Adding…';}
        addToCart(id,qty).then(()=>{if(btn){btn.textContent='Added ✓';setTimeout(()=>{btn.textContent=o;btn.disabled=false;},1300);}})
          .catch(()=>{if(btn){btn.textContent=o;btn.disabled=false;}});
      });
    });
  }

  /* ---------- collection auto-carousel (auto + free manual scroll) ---------- */
  function collectionCarousel(){
    $$('[data-ccarousel]').forEach(box=>{
      if(box.dataset.autoplay==='false')return;
      const track=box.querySelector('.ccarousel__track');if(!track)return;
      const speed=parseInt(box.dataset.speed,10)||3500;
      let timer=null,paused=false;
      const step=()=>{
        const card=track.querySelector('.ccard');if(!card)return;
        const w=card.getBoundingClientRect().width+12;
        const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;
        if(atEnd){track.scrollTo({left:0,behavior:'smooth'});}
        else{track.scrollBy({left:w,behavior:'smooth'});}
      };
      const start=()=>{stop();if(!paused)timer=setInterval(step,speed);};
      const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
      // pause on hover / touch / manual scroll, resume after idle
      let idle;
      const bump=()=>{paused=true;stop();clearTimeout(idle);idle=setTimeout(()=>{paused=false;start();},speed*1.4);};
      ['pointerdown','touchstart','wheel','mouseenter'].forEach(ev=>track.addEventListener(ev,bump,{passive:true}));
      track.addEventListener('mouseleave',()=>{paused=false;start();});
      // pause when offscreen
      if('IntersectionObserver'in window){
        new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)start();else stop();}),{threshold:.2}).observe(box);
      } else start();
    });
  }

  /* ---------- search toggle + clear ---------- */
  function search(){
    // show/hide the clear (×) only when the field has text — prevents a stray second button
    $$('.searchbar input, .searchpage__form input').forEach(inp=>{
      const c=inp.closest('form').querySelector('.s-clear');
      if(!c)return;
      const sync=()=>{ if(inp.value.trim()) c.removeAttribute('hidden'); else c.setAttribute('hidden',''); };
      inp.addEventListener('input',sync); sync();
    });
    document.addEventListener('click',e=>{
      const t=e.target.closest('[data-search-toggle]');
      if(t){
        const pageForm=$('.searchpage__form input');
        if(pageForm){e.preventDefault();pageForm.focus();return;}
        const bar=$('#header-search');if(!bar)return;
        const show=bar.hasAttribute('hidden');
        if(show){bar.removeAttribute('hidden');const i=bar.querySelector('input');if(i)i.focus();}else{bar.setAttribute('hidden','');}
      }
      const c=e.target.closest('[data-search-clear]');
      if(c){e.preventDefault();const form=c.closest('form');const input=form.querySelector('input');if(input){input.value='';input.dispatchEvent(new Event('input'));input.focus();c.setAttribute('hidden','');}const pp=form.querySelector('[data-predictive-panel]');if(pp){pp.hidden=true;pp.innerHTML='';}}
    });
  }

  /* ---------- collection sort + filter (native Shopify) ---------- */
  function collection(){
    document.addEventListener('click',e=>{
      const o=e.target.closest('[data-open]');
      if(o){const sel=o.getAttribute('data-open');const el=$(sel);if(el){el.classList.add('open');document.body.style.overflow='hidden';}return;}
      const c=e.target.closest('[data-close]');
      if(c){const sel=c.getAttribute('data-close');const el=$(sel);if(el){el.classList.remove('open');document.body.style.overflow='';}return;}
      if(e.target.classList.contains('sheet__scrim')){e.target.parentElement.classList.remove('open');document.body.style.overflow='';}
      const tb=e.target.closest('.sheet__tabs button');
      if(tb){const sheet=tb.closest('.sheet');$$('.sheet__tabs button',sheet).forEach(b=>b.classList.remove('on'));tb.classList.add('on');const key=tb.getAttribute('data-tab');$$('[data-vals]',sheet).forEach(p=>p.style.display=p.getAttribute('data-vals')===key?'block':'none');}
    });
    addEventListener('keydown',e=>{if(e.key==='Escape'){$$('.navdrawer.open, .sheet.open').forEach(el=>el.classList.remove('open'));document.body.style.overflow='';}});
  }

  /* ---------- desktop arrows for .sx-rail carousels ---------- */
  function railArrows(){
    if(!window.matchMedia('(min-width:760px)').matches)return;
    $$('.sx-rail').forEach(rail=>{
      if(rail.dataset.arrowed)return;rail.dataset.arrowed='1';
      const track=rail.querySelector('.sx-rail__track');if(!track)return;
      const mk=(dir)=>{const b=document.createElement('button');b.type='button';
        b.className='sx-rail__nav sx-rail__nav--'+dir;b.setAttribute('aria-label',dir==='prev'?'Previous':'Next');
        b.textContent=dir==='prev'?'‹':'›';return b;};
      const prev=mk('prev'),next=mk('next');
      rail.style.position='relative';rail.appendChild(prev);rail.appendChild(next);
      const step=()=>Math.max(240,track.clientWidth*0.8);
      const update=()=>{
        const scrollable=track.scrollWidth>track.clientWidth+4;
        prev.style.display=next.style.display=scrollable?'':'none';
        if(!scrollable)return;
        const max=track.scrollWidth-track.clientWidth-2;
        prev.classList.toggle('off',track.scrollLeft<=2);
        next.classList.toggle('off',track.scrollLeft>=max);
      };
      prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
      next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
      track.addEventListener('scroll',update,{passive:true});
      addEventListener('resize',update,{passive:true});
      setTimeout(update,60);
    });
  }

  /* ---------- product-card inline variant chips ---------- */
  function cardVariants(){
    $$('.pc__opts').forEach(group=>{
      const card=group.closest('.pc');if(!card)return;
      const img=card.querySelector('.pc__img'),amt=card.querySelector('.pc__amt'),
            cmp=card.querySelector('.pc__cmp'),off=card.querySelector('.pc__off');
      // preload variant images for instant swap
      $$('.pc__opt',group).forEach(o=>{if(o.dataset.image){const im=new Image();im.src=o.dataset.image;}});
      $$('.pc__opt',group).forEach(opt=>opt.addEventListener('click',e=>{
        e.preventDefault();e.stopPropagation();
        $$('.pc__opt',group).forEach(o=>o.classList.remove('on'));opt.classList.add('on');
        const price=+opt.dataset.price||0,compare=+opt.dataset.compare||0;
        if(amt&&price)amt.textContent=money(price);
        if(cmp){if(compare>price){cmp.textContent=money(compare);cmp.style.display='';}else cmp.style.display='none';}
        if(off){if(compare>price){off.textContent=Math.round((compare-price)/compare*100)+'% off';off.style.display='';}else off.style.display='none';}
        if(img&&opt.dataset.image&&img.src!==opt.dataset.image)img.src=opt.dataset.image;
      }));
    });
  }

  /* ---------- bestsellers tabs (Men/Women/Unisex) ---------- */
  function featuredTabs(){
    $$('[data-bestsellers]').forEach(sec=>{
      const btns=$$('[data-tab-btn]',sec),panels=$$('[data-tab-panel]',sec);
      btns.forEach(b=>b.addEventListener('click',()=>{
        const key=b.getAttribute('data-tab-btn');
        btns.forEach(x=>x.classList.toggle('on',x===b));
        panels.forEach(p=>{const on=p.getAttribute('data-tab-panel')===key;if(on)p.removeAttribute('hidden');else p.setAttribute('hidden','');});
      }));
    });
  }

  /* ---------- product recommendations on PDP (section render) ---------- */
  function pdpRecs(){
    $$('[data-recommendations]').forEach(box=>{
      const url=box.getAttribute('data-url'),track=box.querySelector('.sx-rail__track')||box.querySelector('.pslider__track');
      if(!url||!track||track.children.length>0)return;
      fetch(url).then(r=>r.text()).then(html=>{
        const doc=new DOMParser().parseFromString(html,'text/html');
        const inner=doc.querySelector('.sx-rail__track')||doc.querySelector('.pslider__track');
        if(inner&&inner.children.length>0){track.innerHTML=inner.innerHTML;cardVariants();railArrows();}
        else{const s=box.closest('section');if(s)s.style.display='none';}
      }).catch(()=>{});
    });
  }

  /* ---------- predictive (smart) search preview ---------- */
  function predictiveSearch(){
    const forms=$$('[data-predictive-form]');if(!forms.length)return;
    const esc=(s)=>(s||'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    forms.forEach(form=>{
      const input=$('[data-predictive-input]',form),panel=$('[data-predictive-panel]',form);
      if(!input||!panel)return;
      let timer=null,lastQ='';
      const close=()=>{panel.hidden=true;panel.innerHTML='';};
      const render=(data,q)=>{
        const prods=(data.resources&&data.resources.results&&data.resources.results.products)||[];
        const colls=(data.resources&&data.resources.results&&data.resources.results.collections)||[];
        if(!prods.length&&!colls.length){
          panel.innerHTML=`<div class="predictive__empty">No matches for “${esc(q)}”. Press Enter to search.</div>`;
          panel.hidden=false;return;
        }
        let html='';
        if(colls.length){
          html+='<div class="predictive__group"><div class="predictive__label">Collections</div>';
          html+=colls.slice(0,3).map(c=>`<a class="predictive__coll" href="${c.url}">${esc(c.title)}</a>`).join('');
          html+='</div>';
        }
        if(prods.length){
          html+='<div class="predictive__group"><div class="predictive__label">Products</div>';
          html+=prods.slice(0,6).map(p=>{
            const img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
            const price=p.price!=null?money(typeof p.price==='number'?p.price:Math.round(parseFloat(p.price)*100)):'';
            return `<a class="predictive__item" href="${p.url}">
              ${img?`<img src="${img}" alt="" loading="lazy">`:'<span class="predictive__ph"></span>'}
              <span class="predictive__info"><span class="predictive__t">${esc(p.title)}</span>${price?`<span class="predictive__p">${price}</span>`:''}</span>
            </a>`;
          }).join('');
          html+='</div>';
        }
        html+=`<a class="predictive__all" href="/search?q=${encodeURIComponent(q)}&type=product">View all results →</a>`;
        panel.innerHTML=html;panel.hidden=false;
      };
      const run=(q)=>{
        const url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(r=>r.json()).then(d=>{if(input.value.trim()===q)render(d,q);}).catch(close);
      };
      input.addEventListener('input',()=>{
        const q=input.value.trim();
        if(q===lastQ)return;lastQ=q;
        clearTimeout(timer);
        if(q.length<2){close();return;}
        timer=setTimeout(()=>run(q),180);
      });
      input.addEventListener('focus',()=>{const q=input.value.trim();if(q.length>=2)run(q);});
      document.addEventListener('click',e=>{if(!form.contains(e.target))close();});
      input.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
    });
  }

  /* ---------- measure mobile bottom-nav height (exact, no gap) ---------- */
  function mbarHeight(){
    const bar=$('.mbar');
    const set=()=>{
      const h=bar&&getComputedStyle(bar).display!=='none'?bar.getBoundingClientRect().height:0;
      document.documentElement.style.setProperty('--mbar-h',h?h+'px':'0px');
    };
    set();
    addEventListener('resize',set,{passive:true});
    addEventListener('orientationchange',set);
    if(bar&&'ResizeObserver'in window){new ResizeObserver(set).observe(bar);}
  }

  /* ---------- footer accordion (mobile) ---------- */
  function footerAccordion(){
    const mq=window.matchMedia('(max-width:759px)');
    const cols=$$('.footer__acc');
    function apply(){cols.forEach(c=>{if(mq.matches)c.removeAttribute('open');else c.setAttribute('open','');});}
    apply();
    if(mq.addEventListener)mq.addEventListener('change',apply);else if(mq.addListener)mq.addListener(apply);
  }

  document.addEventListener('DOMContentLoaded',()=>{
    reveal();drawers();quickAdd();countdowns();heroCarousel();
    pdpVariants();pdpTabs();pdpAccordion();pdpQty();pdpThumbs();pdpForm();pdpRecs();
    search();collection();collectionCarousel();footerAccordion();featuredTabs();cardVariants();railArrows();predictiveSearch();mbarHeight();refreshCart();
  });
  window.AVERRA={addToCart,refreshCart};
})();
